import React, { useEffect, useState } from 'react';
import { Container, Form, Button, Row, Col, Alert, Spinner, Card, InputGroup } from 'react-bootstrap';
import { useAuth } from "./store/AuthContext";
import { useNavigate, Link } from 'react-router-dom';
import { useSchoolYear } from './store/SchoolYearCalculator';
import './CSS/LoginForm.css';

function LoginPage() {
    const [username, setUserNameForm] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loginFailed, setLoginFailed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();
    const { schoolYear, fetchSchoolYear } = useSchoolYear();

    useEffect(() => {
    }, [login]);

    const handleUserNameChange = (e) => {
        setUserNameForm(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            await login(username, password);
            await fetchSchoolYear();
        } catch (error) {
            console.error('Login Error:', error);
            setLoginFailed(true);
        } finally {
            setIsLoading(false);
            setUserNameForm('');
            setPassword('');
            setShowPassword(false);
        }
    };

    return (
        <div className="login-page">
            <Container className="login-page__container">
                <Row className="justify-content-center">
                    <Col xs={11} sm={10} md={5} lg={4}>
                        <Card className="login-card shadow-sm">
                            <Card.Body className="p-4 p-md-5">
                                <div className="login-card__header text-center mb-4">
                                    <h1 className="login-card__title mb-1">UFOMT Staff</h1>
                                    <p className="login-card__subtitle text-muted mb-0">Sign in to your account</p>
                                </div>

                                <Form onSubmit={handleSubmit}>
                                    {loginFailed && (
                                        <Alert variant="danger" className="mb-3" onClose={() => setLoginFailed(false)} dismissible>
                                            Invalid username or password. Please try again.
                                        </Alert>
                                    )}

                                    <Form.Group controlId="username" className="mb-3">
                                        <Form.Label className="login-card__label">Username</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="username"
                                            value={username}
                                            onChange={handleUserNameChange}
                                            placeholder="Enter your username"
                                            required
                                            autoComplete="username"
                                            className="login-card__input py-2"
                                        />
                                    </Form.Group>

                                    <Form.Group controlId="password" className="mb-3">
                                        <Form.Label className="login-card__label">Password</Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                value={password}
                                                onChange={handlePasswordChange}
                                                placeholder="Enter your password"
                                                required
                                                autoComplete="current-password"
                                                className="login-card__input py-2"
                                            />
                                            <Button
                                                type="button"
                                                variant="outline-secondary"
                                                onClick={togglePasswordVisibility}
                                                className="login-card__password-toggle"
                                                aria-label={showPassword ? "Hide password" : "Show password"}
                                                aria-pressed={showPassword}
                                            >
                                                <span
                                                    className={`password-visibility-icon ${showPassword ? 'password-visibility-icon--hide' : 'password-visibility-icon--show'}`}
                                                    aria-hidden="true"
                                                />
                                            </Button>
                                        </InputGroup>
                                    </Form.Group>

                                    <Button
                                        variant="primary"
                                        type="submit"
                                        disabled={isLoading}
                                        className="login-card__submit w-100 py-2 mb-3"
                                    >
                                        {isLoading ? (
                                            <>
                                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                {' '}Signing in...
                                            </>
                                        ) : (
                                            'Sign in'
                                        )}
                                    </Button>

                                    <div className="login-card__links text-center">
                                        <Link to="/forgot-username" className="login-card__link">Forgot username?</Link>
                                        <span className="login-card__separator" aria-hidden="true">·</span>
                                        <Link to="/forgot-password" className="login-card__link">Forgot password?</Link>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default LoginPage;
